import React, { useState, useEffect } from "react";
import { HiDotsVertical } from "react-icons/hi";
import { RiSearchLine, RiAddCircleLine } from "react-icons/ri";
import "./BillingStyle.css";

export const BillingPlans = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="user_container">
      <h1>Plans & Billing</h1>
      <div className="tabContainer">
        <div className="billingTabs">
          <button
            onClick={() => handleTabClick("tab1")}
            className={activeTab === "tab1" ? "active" : ""}
          >
            Tab 1
          </button>
          <button
            onClick={() => handleTabClick("tab2")}
            className={activeTab === "tab2" ? "active" : ""}
          >
            Tab 2
          </button>
        </div>
        <div className="tab-content">
          {activeTab === "tab1" && <div>This is the content of Tab 1.</div>}
          {activeTab === "tab2" && <div>This is the content of Tab 2.</div>}
        </div>
      </div>
    </div>
  );
};
